import { api } from 'common/frontend/api';

interface UsageHistoryQueryReq {
	shopId: string;
	itemId: string;
	startAfter?: string;
	limit?: number;
}

export const getUsageHistory = async (args: UsageHistoryQueryReq) => {
	const { shopId, itemId, startAfter, limit } = args;
	let query = api()
		.usageHistory.get.where('shopId', '==', shopId)
		.whereArray('itemIds', 'array-contains', itemId)
		.where('cancelled', '==', false)
		.orderBy('endDate', 'desc');
	if (startAfter) {
		query = query.startAfter(startAfter);
	}
	if (limit) {
		query = query.limit(limit);
	}
	return query.get();
};
